module.exports = __webpack_public_path__ + "static/media/lock.25a93ab2.svg";